import { useEffect, useState } from 'react';

/**
 * Local wall-clock time as HH:MM:SS.
 *
 * Shown on the pre-tap reward card so the barista can see the screen is live
 * before deciding to tap, and check it against the till. A screenshot shows a
 * stale time.
 *
 * This is a USABILITY aid, not a security control — device clocks are trivially
 * changed. The real controls are the tap itself and the shop's secret word.
 */
export function formatClock(ms: number): string {
  const d = new Date(ms);
  const p = (n: number) => String(n).padStart(2, '0');
  return `${p(d.getHours())}:${p(d.getMinutes())}:${p(d.getSeconds())}`;
}

export function useWallClock(): string {
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    const id = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(id);
  }, []);
  return formatClock(now);
}
